

//-----------------------------------------------
//ロード時起動
//-----------------------------------------------

var time = new Date().getTime();

//全ての読み込みが完了したら実行
$(window).on('load',function () {
  let headerHeight = $('.l-header').outerHeight();
  let urlHash = location.hash;
  if (urlHash) {
    let position = $(urlHash).offset().top - headerHeight;
    $('html, body').animate({ scrollTop: position }, 0);
  }
    loadAnimationStop();
});



//-----------------------------------------------
//ロードアニメーション
//-----------------------------------------------

function loadAnimationStop() {
  
    setInterval(function() {
      $('html').addClass('is-loaded');
    }, 100);
    setInterval(function() {
      firstscript()
    }, 300);

}


// 処理の中身
function firstscript() {
    
   /*---------------------------
   トップ
   --------------------------- */
  // 1文字ずつ表示
    let txtNum = 0;
    let delay = 0;
    $('.top-hero__h1').css({opacity: 1});
    setInterval(function() {
      $('.top-hero__h1').find('span').eq(txtNum).css({
        'opacity': 1,
        'transition-delay': delay + 's',
      });
      txtNum++;
      delay = delay + 0.02;
    }, 100);

}




$(window).on('load scroll', function () {
  $('.js-scroll__anime').each(function () {
    var target = $(this).offset().top;
    var scroll = $(window).scrollTop();
    var height = $(window).height();
    if (scroll > target - height) {
      $(this).addClass('active');
    }
  });

  $('.js-scroll__anime2').each(function () {
    var target = $(this).offset().top;
    var scroll = $(window).scrollTop();
    var height = $(window).height();
    if (scroll > target - height) {
      $(this).addClass('active2');
    }
  });
});

ScrollReveal().reveal('.animateRight', {
  duration: 1200,
  distance: '480px',
  origin: 'right',
  viewFactor: '0.2'
});

ScrollReveal().reveal('.animateLeft', {
  duration: 1500,
  distance: '480px',
  origin: 'left',
  viewFactor: '0.2',
});

ScrollReveal().reveal('.animateBottom', {
  duration: 1200,
  distance: '100px',
  origin: 'bottom',
  viewFactor: '0.2',
});

ScrollReveal().reveal('.animateslow', {
  duration: '800',
  viewFactor: '0.2',
  reset: 'true'
});






/*===============================================
	 * スクロールマジックで表示
================================================*/

const $section = document.querySelectorAll(".js-scrollSection");
let width;
let imageHeight = $(".top-contents__image").height();

if (window.innerWidth >= 1600) {
  width = 1.6;
} else if (window.innerWidth < 1600 && window.innerWidth >= 1025) {
  width = 1.6;
} else if (window.innerWidth < 1025) {
  width = 1;
}

let controller = new ScrollMagic.Controller();
for (let i = 0; i < $section.length; i++) {
  let scene = new ScrollMagic.Scene({
    triggerElement: $section[i],
    triggerHook: "onEnter",
    reverse: false,
    offset: 200,
  }).addTo(controller);
  scene.on("enter", () => {
    //console.log('enter');
    $section[i].classList.add("is-view");
    $($section[i])
      .find(".top-contents__image-bg")
      .css({
        clip:
          "rect(0px " + $(".top-contents__right").width() * width + "px " + imageHeight + "px 0px)",
      });
    $($section[i])
      .find(".top-contents__image-main")
      .css({
        clip:
          "rect(0px " + $(".top-contents__right").width() * width + "px " + imageHeight + "px 0px)",
      });
  });
  scene.on("end", () => {
    //console.log('end');
    scene.destroy(true);
  });
}










// glowAnimeにglowというクラス名を付ける定義
function GlowAnimeControl() {
  $('.glowAnime').each(function () {
    var elemPos = $(this).offset().top - 50;
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll >= elemPos - windowHeight) {
      $(this).addClass("glow");

    } else {
      $(this).removeClass("glow");
    }
  });
}

function GlowAnimeControl2() {
  $('.glowAnime2').each(function () {
    var elemPos = $(this).offset().top - 50;
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll >= elemPos - windowHeight) {
      $(this).addClass("glow");

    } else {
      $(this).removeClass("glow");
    }
  });
}

function GlowAnimeControl3() {
  $('.glowAnime3').each(function () {
    var elemPos = $(this).offset().top - 50;
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll >= elemPos - windowHeight) {
      $(this).addClass("glow");

    } else {
      $(this).removeClass("glow");
    }
  });
}



// 画面が読み込まれたらすぐに動かしたい場合の記述
$(window).on('load', function () {
  //spanタグを追加する
  var element = $(".glowAnime");
  element.each(function () {
    var text = $(this).text();
    var textbox = "";
    text.split('').forEach(function (t, i) {
      if (t !== " ") {
        if (i < 10) {
          textbox += '<span style="animation-delay:.' + i + 's;">' + t + '</span>';
        } else {
        var n = i / 10;
          textbox += '<span style="animation-delay:' + n + 's;">' + t + '</span>';
        }

      } else {
        textbox += t;
      }
    });
    $(this).html(textbox);
  });

  var element2 = $(".glowAnime2");
  element2.each(function () {
    var text2 = $(this).text();
    var textbox2 = "";
    text2.split('').forEach(function (t, i) {
      if (t !== " ") {
        if (i < 10) {
          textbox2 += '<span style="animation-delay:.' + i + 's;">' + t + '</span>';
        } else {
        var n = i / 10;
          textbox2 += '<span style="animation-delay:' + n + 's;">' + t + '</span>';
        }

      } else {
        textbox2 += t;
      }
    });
    $(this).html(textbox2);
  });

  var element3 = $(".glowAnime3");
  element3.each(function () {
    var text3 = $(this).text();
    var textbox3 = "";
    text3.split('').forEach(function (t, i) {
      if (t !== " ") {
        if (i < 10) {
          textbox3 += '<span style="animation-delay:.' + i + 's;">' + t + '</span>';
        } else {
        var n = i / 10;
          textbox3 += '<span style="animation-delay:' + n + 's;">' + t + '</span>';
        }

      } else {
        textbox3 += t;
      }
    });
    $(this).html(textbox3);
  });

  setInterval(function() {
    GlowAnimeControl();/* アニメーション用の関数を呼ぶ*/
  }, 100);
  setInterval(function() {
    GlowAnimeControl2();/* アニメーション用の関数を呼ぶ*/
  }, 1000);
  setInterval(function() {
    GlowAnimeControl3();/* アニメーション用の関数を呼ぶ*/
  }, 2000);


});// ここまで画面が読み込まれたらすぐに動かしたい場合の記述

